import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {CloseIcon, HotIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {RPModal} from "../../atoms/RPModal";
import {getPromotionTypeName} from "../helpers/PromotionType";
import {usePromotionModal} from "../hooks/use_promotion_modal";
import {IPromotionModalPromotion, IPromotionModalProps} from "../types/IPromotionModal";

export type {IPromotionModalPromotion, IPromotionModalProps};

export const PromotionModal = (props: IPromotionModalProps) => {
    const {isMobile} = useUserDevice();
    const {isOpen, promotionType, promotionStyle, promotionTrackingContext, applicationModalButtonProps, close, createAskForPromotionHandler} =
        usePromotionModal(props);

    return (
        <RPModal
            isOpen={isOpen}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PROMOTION_DELAYED_MODAL}
            closeButton={(onModalClose) => (
                <CloseIcon
                    size="2"
                    wrapperSize="4.8"
                    wrapperType="circle"
                    wrapperColor={isMobile ? "var(--colors-white)" : "transparent"}
                    onClick={onModalClose}
                    className={closeButtonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PROMOTION_DELAYED_MODAL_CLOSE_BUTTON}
                />
            )}
            onModalClose={close}
            className={modalStyle}
        >
            <div className={rowStyle}>
                <div className={iconCellStyle}>
                    {promotionStyle.icon ?? <HotIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-highlight)" wrapperType="circle" />}
                </div>

                <div className={headCellStyle}>
                    <Text as="p" variant="mini_header" mb={1.5} className={promotionTypeBadgeStyle} style={{backgroundColor: promotionStyle.color}}>
                        {getPromotionTypeName(promotionType)}
                    </Text>

                    <Text as="p" variant="headline_6" align="left">
                        {promotionTrackingContext.creativeName}
                    </Text>
                </div>

                <div className={bodyCellStyle}>
                    {!!promotionTrackingContext.promotionContent && (
                        <Text as="p" variant="body_copy_2" mb={1.5} className={descriptionTextStyle} align="left">
                            {promotionTrackingContext.promotionContent}
                        </Text>
                    )}

                    <div className={ctaWrapStyle}>
                        <ApplicationModalButton
                            {...applicationModalButtonProps}
                            amplitudePlacement={props.propertyId ? "rp_promotion_section_property" : "rp_promotion_section_offer"}
                            render={({openModal}) => (
                                <Button
                                    type="button"
                                    variant="filled_primary"
                                    size="small"
                                    className={promotionButtonStyle}
                                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PROMOTION_DELAYED_MODAL_CTA}
                                    onClick={createAskForPromotionHandler(openModal)}
                                >
                                    {InquiryButtonTypeName.ASK_FOR_PROMOTION}
                                </Button>
                            )}
                        />
                    </div>
                </div>
            </div>
        </RPModal>
    );
};

const modalStyle = css({
    bottom: -1,
    p: 4,
    overflow: "unset",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,

    md: {
        bottom: "unset",
        maxWidth: "487px",
        borderRadius: 3
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    right: "50%",
    transform: "translate(50%, 0)",
    md: {
        top: -3,
        right: -3,
        transform: "unset"
    }
});

const rowStyle = css({
    display: "grid",
    width: "100%",
    textAlign: "left",
    gridTemplateColumns: "66px 1fr",
    gridTemplateRows: "auto auto",
    gridTemplateAreas: `"icon head" "body body"`,
    columnGap: 2,
    rowGap: 2,

    md: {
        gridTemplateColumns: "74px 1fr",
        gridTemplateAreas: `"icon head" "icon body"`
    }
});

const iconCellStyle = css({
    gridArea: "icon",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    minWidth: 0
});

const headCellStyle = css({
    gridArea: "head",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minWidth: 0
});

const bodyCellStyle = css({
    gridArea: "body",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    minWidth: 0,
    width: "100%",
    boxSizing: "border-box"
});

const promotionTypeBadgeStyle = css({
    alignSelf: "flex-start",
    textTransform: "uppercase",
    display: "inline-flex",
    px: "0.1rem",
    mb: 1.5
});

const descriptionTextStyle = css({
    width: "100%",
    boxSizing: "border-box"
});

const ctaWrapStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    boxSizing: "border-box"
});

const promotionButtonStyle = css({
    py: "1rem",
    px: "1.4rem",
    boxSizing: "border-box",
    width: "100%",

    md: {
        width: "auto"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {CloseIcon, HotIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {RPModal} from "../../atoms/RPModal";
import {getPromotionTypeName} from "../helpers/PromotionType";
import {usePromotionModal} from "../hooks/use_promotion_modal";
import {IPromotionModalPromotion, IPromotionModalProps} from "../types/IPromotionModal";

export type {IPromotionModalPromotion, IPromotionModalProps};

export const PromotionModal = (props: IPromotionModalProps) => {
    const {isMobile} = useUserDevice();
    const {isOpen, promotionType, promotionStyle, promotionTrackingContext, applicationModalButtonProps, close, createAskForPromotionHandler} =
        usePromotionModal(props);

    return (
        <RPModal
            isOpen={isOpen}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PROMOTION_DELAYED_MODAL}
            closeButton={(onModalClose) => (
                <CloseIcon
                    size="2"
                    wrapperSize="4.8"
                    wrapperType="circle"
                    wrapperColor={isMobile ? "var(--colors-white)" : "transparent"}
                    onClick={onModalClose}
                    className={closeButtonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PROMOTION_DELAYED_MODAL_CLOSE_BUTTON}
                />
            )}
            onModalClose={close}
            className={modalStyle}
        >
            <div className={rowStyle}>
                <div className={iconCellStyle}>
                    {promotionStyle.icon ?? <HotIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-highlight)" wrapperType="circle" />}
                </div>

                <div className={headCellStyle}>
                    <Text as="p" variant="mini_header" mb={1.5} className={promotionTypeBadgeStyle} style={{backgroundColor: promotionStyle.color}}>
                        {getPromotionTypeName(promotionType)}
                    </Text>

                    <Text as="p" variant="headline_6" align="left">
                        {promotionTrackingContext.creativeName}
                    </Text>
                </div>

                <div className={bodyCellStyle}>
                    {!!promotionTrackingContext.promotionContent && (
                        <Text as="p" variant="body_copy_2" mb={1.5} className={descriptionTextStyle} align="left">
                            {promotionTrackingContext.promotionContent}
                        </Text>
                    )}

                    <div className={ctaWrapStyle}>
                        <ApplicationModalButton
                            {...applicationModalButtonProps}
                            amplitudePlacement={props.propertyId ? "rp_promotion_section_property" : "rp_promotion_section_offer"}
                            render={({openModal}) => (
                                <Button
                                    type="button"
                                    variant="filled_primary"
                                    size="small"
                                    className={promotionButtonStyle}
                                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PROMOTION_DELAYED_MODAL_CTA}
                                    onClick={createAskForPromotionHandler(openModal)}
                                >
                                    {InquiryButtonTypeName.ASK_FOR_PROMOTION}
                                </Button>
                            )}
                        />
                    </div>
                </div>
            </div>
        </RPModal>
    );
};

const modalStyle = css({
    bottom: -1,
    p: 4,
    overflow: "unset",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,

    md: {
        bottom: "unset",
        maxWidth: "487px",
        borderRadius: 3
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    right: "50%",
    transform: "translate(50%, 0)",
    md: {
        top: -3,
        right: -3,
        transform: "unset"
    }
});

const rowStyle = css({
    display: "grid",
    width: "100%",
    textAlign: "left",
    gridTemplateColumns: "66px 1fr",
    gridTemplateRows: "auto auto",
    gridTemplateAreas: `"icon head" "body body"`,
    columnGap: 2,
    rowGap: 2,

    md: {
        gridTemplateColumns: "74px 1fr",
        gridTemplateAreas: `"icon head" "icon body"`
    }
});

const iconCellStyle = css({
    gridArea: "icon",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    minWidth: 0
});

const headCellStyle = css({
    gridArea: "head",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minWidth: 0
});

const bodyCellStyle = css({
    gridArea: "body",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    minWidth: 0,
    width: "100%",
    boxSizing: "border-box"
});

const promotionTypeBadgeStyle = css({
    alignSelf: "flex-start",
    textTransform: "uppercase",
    display: "inline-flex",
    px: "0.1rem",
    mb: 1.5
});

const descriptionTextStyle = css({
    width: "100%",
    boxSizing: "border-box"
});

const ctaWrapStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    boxSizing: "border-box"
});

const promotionButtonStyle = css({
    py: "1rem",
    px: "1.4rem",
    boxSizing: "border-box",
    width: "100%",

    md: {
        width: "auto"
    }
});
